export default {
  disability: {
    header: 'Disability Insurance',
    body: `<div class="title-sm">Your Biggest Asset is You</div>
<p>When it comes to protecting your assets, one of the most important things you can insure isn’t a
material object like your car or home – it’s your ability to work and earn a living.
At SIG & Associates, we know that like most people, you depend on your income to pay bills,
put food on the table, and provide for your family. But if you get sick or injured and can’t work,
you’ll need to be protected in order to maintain your standard of living.</p>

<p>With disability income Insurance from SIG & Associates, you can continue to pay your bills and keep you
and your family from going into serious debt. If you can’t work as a result of injury or other illness,
a disability insurance policy will pay a portion of your income, usually between 50 and 70 percent.</p>

<p>Policies can vary greatly depending on the individual, and the duration and amount for which you
are reimbursed are determined by the nature of the disabling accident. Like life insurance,
disability is purchased for a period of time, such as a two or five-year term, and benefits
will only be paid if you become disabled during the term of the policy.</p>

<p>Choosing the right disability coverage is important. In the event you become disabled,
you'll want to ensure that you and your family have enough coverage. A representative at
SIG & Associates will look at the individual factors in your life and work situation,
and help design the best policy that meets your personal insurance needs.</p>

<p><small><i>SIG & Associates provides disability insurance to individuals in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  retire: {
    header: 'Retiree Health Coverage',
    body: `<div class="title-sm">Keep your Retirees Happy</div>
<p>The number of retirees will continue to increase, whether or not your business and its resources do as well.
This burden can be overbearing for you and your business. SIG & Associates understands the need
for you to keep retirees happy while maintaining the efficiency needed to run a successful company.
We offer retiree medical plans that will help benefit your business and your former employees.</p>

<p>SIG & Associates offers quality coverage solutions to your business, including:</p>
<ul>
<li>Medicare</li>
<li>Customized retirement plans</li>
<li>Prescription coverage</li>
</ul>

<p>Contact a representative at SIG & Associates today to go over retiree health coverage options for your business.</p>

<p><small><i>SIG & Associates provides retiree health coverage to businesses in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  'group-d': {
    header: 'Group Disability Insurance',
    body: `<div class="title-sm">Effective Solutions for Managing your Employees</div>
<p>Happy employees make for a productive workplace, thus helping assure that they’re protected
creates a more positive working environment. SIG & Associates understands that income stability
for workers isn’t enough. What happens if an employee can’t work due to a disabling illness or injury?</p>

<p>SIG & Associates provides group disability solutions that will assist employees in replacing parts of
their income while they are absent from work, and will provide the expertise needed to reduce employee absences,
ensuring that your business can continually run as efficiently as possible.</p>

<p>Our group disability coverage options include:</p>

<ul>
<li>Short-term disability</li>
<li>Long-term disability</li>
<li>Statutory disability</li>
<li>Absence management services</li>
</ul>

<p>Contact an insurance specialist at SIG & Associates to set up a consultation.</p>
<p><small><i>SIG & Associates provides group disability insurance to businesses in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  benefits: {
    header: 'Group Benefits',
    body: `<div class="title-sm">Keep your Employees Happy with Group Benefits</div>

<p>A single policy for all employees of the same company, along with their dependents,
provides bottom line coverage for employers and employees alike. Under a group benefit plan,
the employer or association will be issued a master policy that will be
distributed to all employees working for that particular company.</p>

<p>SIG & Associates proudly offers these group benefits, plus many more:</p>

<ul>
<li>Group disability</li>
<li>Life & accident</li>
<li>Leave management</li>
<li>Retiree health coverage</li>
<li>Voluntary benefits</li>
</ul>

<p>Contact a representative at SIG & Associates to go over group benefit options for your business.</p>

<small><i>SIG & Associates provides group benefits to businesses in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  life: {
    header: 'Individual Life Insurance',
    body: `<div class="title-sm">Reassurance for you and your Loved Ones</div>
<p>Many individuals consider life insurance to be the cornerstone of a sound financial plan. And while no one
likes to think about passing on, Life Insurance can relieve you of the financial worry
your loved ones may face in the event of your passing.</p>

<p>Your beneficiaries will be able to use your Life Insurance policy to help pay for anything
from expensive funeral costs and estate taxes to making up for lost income or funding your child’s education.
It can even be used to continue payments on your mortgage to help ensure that the family home stays in the family.</p>

<p>At SIG & Associates, we know that choosing a Life Insurance plan is a big decision with many important
factors to consider. Our knowledgeable team of insurance professionals is committed to walking you through
the process and providing you with the best insurance solution to give
you and your family the reassurance they deserve.</p>

<div class="title-sm">Types of Individual Life Insurance</div>

<p>SIG & Associates offers several different coverage options for
your consideration including <b>term life, whole life, and more</b>.</p>

<p><b>Term Life</b> – This is typically the simplest and least expensive insurance option.
Term life insurance provides coverage at a fixed rate for a specified period of time.
It’s a benefit policy that’s used primarily to cover financial responsibilities of the insured,
with the benefit to be paid only if the insured were to die during the specified term.
Most term life policies can be converted to a more permanent insurance
solution such as whole life or universal life insurance.</p>

<p>There are two types of term life insurance:</p>

<ul>
<li><b>Annual Renewable Term</b> is purchased for a period of one year, with the death benefit to be paid only if
the insured were to die during that one-year term, along with the option to renew after the term period.</li>
<li><b>Level Term Life</b> guarantees a fixed premium for a given period of time, usually in terms of
10, 15, 20, or 30 years. Your premium is based on your age and coverage options, with longer terms being more expensive.</li>
</ul>

<p><b>Whole Life</b> – As the most common type of permanent insurance, a whole life policy
guarantees a death benefit for the lifetime of the insured as well as a cash value account for savings.
Your premium remains constant throughout the duration of policy while payments over
and above your premium are credited to your savings, which earn a fixed rate of interest.</p>

<div class="title-sm">SIG & Associates is here for you</div>

<p>There are many things to take into account when purchasing life insurance,
and changes in your life situation can reflect changes in your insurance requirements.
That’s why it’s important to carefully consider the different policy options and
ensure that you have the right solution to meet your long-term life insurance needs.</p>

<p>An insurance specialist with SIG & Associates will review your current life
insurance situation and help you design a policy to plan for the future.</p>

<p>At the end of the day, one of the biggest investments you can make is an investment in yourself.</p>

<p><small><i>As your personal situations change (i.e., marriage, birth of a child or job promotion),
so will your life insurance needs. Care should be taken to ensure this product is suitable for your
long-term life insurance needs. You should weigh any associated costs before making a purchase.
Life insurance has fees and charges associated with it that include costs of insurance that vary with such
characteristics of the insured as gender, health and age, and has additional charges
for riders that customize a policy to fit your individual needs.</i></small></p>

<p><small><i>SIG & Associates provides life insurance to individuals in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  health: {
    header: 'Retiree Health Coverage',
    body: `<div class="title-sm">Keep your Retirees Happy</div>
<p>The number of retirees will continue to increase, whether or not your business and its resources do as well.
This burden can be overbearing for you and your business. SIG & Associates understands the need
for you to keep retirees happy while maintaining the efficiency needed to run a successful company.
We offer retiree medical plans that will help benefit your business and your former employees.</p>

<p>SIG & Associates offers quality coverage solutions to your business, including:</p>

<ul>
<li>Medicare</li>
<li>Customized retirement plans</li>
<li>Prescription coverage</li>
</ul>

<p>Contact a representative at SIG & Associates today to go over retiree health coverage options for your business.</p>

<p><small><i>SIG & Associates provides retiree health coverage to businesses in Wichita Falls,
Haslet, Decatur, Prosper, Vernon, Garland, and surrounding areas.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  voluntary: {
    header: 'Voluntary Benefits',
    body: `<div class="title-sm">Protect your Employees and your Business</div>
<p>At SIG & Associates, we understand that in order to maintain a happy, productive workplace,
you need to hold on to quality employees. The best way to keep employees happy is by addressing their
concerns with a benefits package that fits their needs. If you work with them, they’ll work for you.</p>

<p>Here are some of the voluntary benefits we offer:</p>

<ul>
<li>Disability services</li>
<li>Life insurance plans</li>
<li>Health insurance plans</li>
</ul>

<p>Contact a representative at SIG & Associates to go over all of the voluntary benefits solutions we offer.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/employeeHelper.js